var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGoldAccount = function SvgGoldAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D4BB5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.44 12.384c.064 2.487-1.874 4.556-4.328 4.622-2.453.066-4.493-1.896-4.556-4.382-.063-2.487 1.875-4.556 4.329-4.622 2.453-.067 4.493 1.896 4.556 4.382z",
    stroke: "#020814",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23s-3.134-3.42-7-3.42S9 23 9 23",
    stroke: "#020814",
    strokeWidth: 1.8
  })));
};
export default SvgGoldAccount;